export class UserName {
    studentId?: Number;
    email?: string;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    extensionName?: string;
}

export class UserEmail {
    studentId?: Number;
    oldEmail?: string;
    newEmail?: string;
}

export class UserDelete {
    studentId?: Number;
}

export class UserArchived {
    studentId?: Number;
}

export class User {
    accessName?: string;
    address?: Address;
    birthDate?: string;
    birthPlace?: string;
    citizenship?: string;
    civilStatus?: string;
    createdAt?: string;
    createdBy?: string;
    customId?: string;
    deletedAt?: string;
    deletedBy?: string;
    dsCustomId?: string;
    dsProfileId?: Number;
    email?: string;
    emailConfirmed?: string;
    extensionName?: string;
    firstName?: string;
    fullName?: string;
    gender?: string;
    id?: Number;
    luxandId?: Number;
    lastName?: string;
    middleName?: string;
    mobile?: string;
    password?: string;
    photo?: string;
    race?: string;
    referralCode?: string;
    school?: School;
    status?: string;
    token?: string;
    tokenReset?: string;
    tokenValidate?: string;
    updatedAt?: string;
    updatedBy?: string;
    userAccessId?: string;
    userType?: string;
    subscriptionType?: string;
    confirmPassword?: string;
    moduleStatus?: string;
    courseId?: Number;
    driverLicense?: string;
    ltoClientId?: string;
    ofw?: string;
    nationality?: string;
    educationalAttainment?: string;
    taxId?: string;
    bloodType?: string;
    complexion?: string;
    bodyType?: string;
    eyeColor?: string;
    hairColor?: string;
    weight?: string;
    height?: string;
    organDonor?: string;
    emergencyContactName?: string;
    emergencyContactMobile?: string;
    emergencyContactAddress?: string;
    employerName?: string;
    employerAddress?: string;
    motherMaidenLastName?: string;
    motherMaidenFirstName?: string;
    motherMaidenMiddleName?: string;
    motherMaidenExtensionName?: string;
    fatherLastName?: string;
    fatherFirstName?: string;
    fatherMiddleName?: string;
    fatherExtensionName?: string;
    spouseLastName?: string;
    spouseFirstName?: string;
    spouseMiddleName?: string;
    spouseExtensionName?: string;
    logoutCount?: Number;
    lastLogout?: string;
    faceFailedCount?: Number;
    ofwCountry?: string;
    driverLicenseClass?: string;
    sourceInfo?: string;
    barangay?: string;
    block?: string;
    city?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    postalCode?: string;
    province?: string;
    region?: string;
    street?: string;
    archived?: string;
}

export class Address {
    barangay?: string;
    block?: string;
    city?: string;
    country?: string;
    latitude?: string;
    longitude?: string;
    postalCode?: string;
    province?: string;
    region?: string;
    street?: string;
}

export class School {
    id: Number;
    companyEmail?: string;
    companyName?: string;
    contactPerson?: string;
    customId?: string;
    instructorFullName?: string;
    instructorLTOAccreditationNo?: string;
    latitude?: string;
    logo?: string;
    longitude?: string;
    ltoAccreditationNo?: string;
    mobile?: string;
    telephone?: string;
    address?: Address;
    referralCode?: string;
    fullAddress?: string;
}

export class Login {
    email?: string;
    password?: string;
}

export class ChangePassword {
    oldPassword?: string;
    newPassword?: string;
}

export interface UserPhoto {
    filepath: string;
    webviewPath: string;
}

export interface TransferStudentAccount {
    email: string;
    dsProfileId: Number;
}

export interface DrivingSchoolDeckingStatus {
    id:Number;
    seqNo:Number;
    dsProfileId:Number;
    dsCustomId: string;
    companyName: string;
    region: string;
    province: string;
    status: string;
}
